import React, { useCallback, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import AvailableAPIs from "../components/APIPlaygroundComponents/AvailableAPIs";
import Instructions from "../components/APIPlaygroundComponents/Instructions";
import PlaygroundForm from "../components/APIPlaygroundComponents/PlaygroundForm";
import axios from "axios";
import classes from "./APIPlayground.module.scss";
import Button from "../components/UI/Button";
import JsonObject from "../components/APIPlaygroundComponents/JsonObject";
import Curl from "../components/APIPlaygroundComponents/Curl";
import useWindowSize from "../hooks/useWindowSize";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import { OrgIdContext } from "../store/orgId_context";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const APIPlayground = () => {
  const [activeApi, setActiveApi] = useState(null);
  const [activeApiData, setActiveApiData] = useState(null);
  const [currentJson, setCurrentJson] = useState(null);
  const [currentCurl, setCurrentCurl] = useState(null);
  const [response, setResponse] = useState(null);
  const [schema, setSchema] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { width } = useWindowSize();

  const { connectionKey, integrationDevice } = useContext(OrgIdContext);

  const onUpdateJsonHandler = useCallback((json) => setCurrentJson(json), []);

  const onUpdateCurlHandler = useCallback((curl) => setCurrentCurl(curl), []);

  const onChooseApiHandler = (newApi) => {
    setActiveApi(newApi);

    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Metadata.DescribeService",
          params: {
            service: `EUeInvoices.${newApi}`,
          },
          id: 5,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result) {
          setActiveApiData(res.data.result);
          let apiSchema = res.data.result;
          const removeKeysRecursively = (obj) => {
            for (let key in obj) {
              if (key === "format") {
                delete obj[key];
              } else if (typeof obj[key] === "object") {
                removeKeysRecursively(obj[key]);
              }
            }
          };
          removeKeysRecursively(apiSchema);
          setSchema(apiSchema);
        }
      });
  };

  const onSubmitCallHandler = () => {
    setIsLoading(true);
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT ||
          window.location.origin + "/json.rpc",
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: `EUeInvoices.${activeApi}`,
            args: currentJson,
          },
          id: 31,
        },
        {
          withCredentials: false,
          headers: {
            Authorization: `IoT ${integrationDevice}:EUeInvoices`,
            "D3Pro-PreferAuthorizationOverSession": "True",
            "D3Pro-NoSession": "True",
          },
        }
      )
      .then((res) => {
        setResponse(res.data);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>API Playground | DDD Invoices</title>
      </Helmet>
      {width > 768 && (
        <div className={`w-100 h-100 p-5 ${classes.container}`}>
          <Container className="h-100" style={{ maxWidth: "100%" }}>
            <Row className="h-100">
              <Col className="col-3" style={{ height: '100%', overflowY: 'auto' }}>
                <AvailableAPIs
                  onChooseApiHandler={onChooseApiHandler}
                  activeApi={activeApi}
                />
              </Col>
              <Col className="col-4 h-100">
                <Container className="d-flex gap-3 flex-column h-100">
                  <Row className="flex-grow-2">
                    {activeApiData && <Instructions apiData={activeApiData} />}
                  </Row>
                  <Row
                    className={`${classes["json-form-container"]} flex-grow-1`}
                  >
                    {activeApiData && (
                      <PlaygroundForm
                        // schema={activeApiData.properties}
                        schema={schema}
                        onJsonChange={onUpdateJsonHandler}
                        onSetCurlHandler={onUpdateCurlHandler}
                        activeApi={activeApi}
                      />
                    )}
                  </Row>
                </Container>
              </Col>
              <Col className="col-4 h-100">
                <Container className="d-flex gap-3 flex-column h-100">
                  {activeApiData && (
                    <>
                      <Row
                        className={`flex-grow-1 ${classes["json-container"]}`}
                      >
                        <Button
                          style={{ height: "fit-content" }}
                          onClick={onSubmitCallHandler}
                        >
                          Submit
                        </Button>
                        <JsonObject response={response} isLoading={isLoading} />
                      </Row>
                      <Row
                        className={`${classes["json-form-container"]} flex-grow-2`}
                      >
                        <Curl
                          currentCurl={currentCurl}
                          currentJson={currentJson}
                          activeApi={activeApi}
                        />
                      </Row>
                    </>
                  )}
                </Container>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default APIPlayground;
